import '../App.css';

import plane from '../assets/images/plane.png';

function Hero() {
    return (
        <section className="hero-section" id="home">

            <div className="container">

                <div className="row align-items-center">

                    <div className="col-lg-5">

                        <div className="hero-content">

                            <h1>

                                The <br />

                                <span>Crypto Airline.</span>

                            </h1>

                            <h2>
                                Fly Together. Own the Journey.
                            </h2>

                            <p>
                                SkyGoose is the world's first
                                community-powered crypto airline.
                                Every booking fuels the flock.
                            </p>

                            <a
                                href="#"
                                className="buy-btn"
                            >

                                <img
                                    src={plane}
                                    alt=""
                                />

                                BUY $GOOSE

                            </a>

                        </div>

                    </div>

                    <div className="col-lg-7"></div>

                </div>

            </div>

        </section>
    );
}

export default Hero;